﻿import axios from 'axios';
import Mapper from '../utils/Mapper';
import {APIUrl, ProductIds} from '../constants/ApplicationConstants.js';
import YourDetailsActions from '../actions/YourDetailsActions.js';
import {MappingConfigurations as YourDetailsMappingConfig} from '../constants/YourDetailsConstants.js';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';

﻿module.exports = {
﻿    getCountryList: function() {
        const productId = ProductIds.SUPER;
﻿        const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.COUNTRY_LIST;

﻿        axios.get(url)
﻿            .then(ThrowIfStatusNotOk)
﻿            .then((response) => {
﻿                const result = Mapper.arrayOfObjectMapper(response.data, YourDetailsMappingConfig.Country);
﻿                YourDetailsActions.loadCountryList(result);
﻿            })
﻿            .catch((error) => {
﻿                throw Error('Country List', error);
﻿            });

﻿    },
﻿    getTfnExemptionList: function() {
         const productId = ProductIds.SUPER;
﻿        const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.TFN_EXEMPTIONS_LIST;

﻿        axios.get(url)
﻿            .then(ThrowIfStatusNotOk)
﻿            .then((response) => {
﻿                const result = Mapper.arrayOfObjectMapper(response.data, YourDetailsMappingConfig.TfnExemption);
﻿                YourDetailsActions.loadTfnExemptionList(result);
﻿            })
﻿            .catch((error) => {
﻿                throw Error('TFN Exemption List', error);
﻿            });
﻿    },
﻿    getTitleList: function() {
        const productId = ProductIds.SUPER;
﻿        const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.TITLE_LIST;

﻿        axios.get(url)
﻿            .then(ThrowIfStatusNotOk)
﻿            .then((response) => {
﻿                const data = response.data;

﻿                data.m = Mapper.arrayOfObjectMapper(data.m, YourDetailsMappingConfig.Title);
﻿                data.f = Mapper.arrayOfObjectMapper(data.f, YourDetailsMappingConfig.Title);
﻿                data.default = Mapper.arrayOfObjectMapper(data.default, YourDetailsMappingConfig.Title);
﻿                YourDetailsActions.loadTitleList(data);
﻿            })
﻿            .catch((error) => {
﻿                throw Error('Title List', error);
﻿            });
     },
     getSourceOfFundList: function () {
         const url = APIUrl.BASE_PRODUCTS_URL + APIUrl.SOURCEOFFUND_LIST;

         axios.get(url)
             .then(ThrowIfStatusNotOk)
             .then((response) => {
                 const result = Mapper.arrayOfObjectMapper(response.data, YourDetailsMappingConfig.sourceOfFund);
                 YourDetailsActions.loadSourceOfFundList(result);
             })
             .catch((error) => {
                 throw Error('Source Of Fund List', error);
             });
     },
     getSourceOfWealthList: function () {
        const url = APIUrl.BASE_PRODUCTS_URL + APIUrl.SOURCEOFWEALTH_LIST;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                const result = Mapper.arrayOfObjectMapper(response.data, YourDetailsMappingConfig.sourceOfWealth);
                YourDetailsActions.loadSourceOfWealthList(result);
            })
            .catch((error) => {
                throw Error('Source Of Wealth List', error);
            });
    }
﻿};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/YourDetailsAPI.js